var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-collect-component",class:[{
       'is-bottom': _vm.position === 'bottom',
       'is-top': _vm.position === 'top',
       'is-collected': _vm.collected,
       }],on:{"click":_vm.handleClick}},[_c('ym-icon',{staticClass:"product-collect-icon",attrs:{"name":_vm.statusMap}}),_c('div',{staticClass:"product-collect-desc"},[_vm._v(_vm._s(_vm.textMap))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }